// import dayjs from '../utils/dayjs';
import LinkToMemberDetails from './LinkToMemberDetails';

const CreatedBy = ({ className, user, createdAt }) => (
  <p className={className || ''}>
    {'By '}
    {user
      ? <LinkToMemberDetails member={user} />
      : '[Unclaimed]'
    }
    {/*{` about ${dayjs(createdAt).fromNow()}`}*/}
  </p>
);

export default CreatedBy;
